<template>
    <span class="status-bubble" :class="statusClass"><span class="white-text fa" :class="arrowClass"></span>{{ Math.abs(stamp.num_stamps) }}</span>
</template>

<script>

export default {

    props: [ 'stamp' ],

    computed: {

        statusClass() {
            return this.stamp.num_stamps > 0 ? 'good-bg' : 'bad-bg';
        },

        arrowClass() {
            return this.stamp.num_stamps > 0 ? 'fa-arrow-up' : 'fa-arrow-down';
        },

    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/passport/LedgerItemValue.vue